module.exports = __webpack_public_path__ + "71c55a0366a7125f2bd34405d5f3f32f.MP3";